import {writable} from 'svelte/store'
import {t} from '../i18n'

export type Flash = {
  type: 'notice' | 'error'
  message: string
  removing?: boolean
}

function flashStore() {
  const {subscribe, update} = writable<Flash[]>([])

  const serverFlashes = (window as any).flash || []
  for (const [type, message] of serverFlashes) {
    update(f => [{type: type as Flash['type'], message}, ...f])
  }

  const show = (message: Flash['message'], type: Flash['type'] = 'notice') => {
    const flash = {message, type}
    update(flashes => [flash, ...flashes])

    if (type !== 'error') {
      setTimeout(() => {
        close(flash)
      }, 4000)
    }
  }

  const close = (flash: Flash) => {
    const newFlash = {...flash, removing: true}
    update(flashes => flashes.map(f => f === flash ? newFlash : f))

    setTimeout(() => {
      remove(newFlash)
    }, 300)
  }

  const remove = (flash: Flash) => {
    update(flashes => flashes.filter(f => f !== flash))
  }

  return {
    subscribe,
    close,
    show
  }
}


export const flash = flashStore()